<template>
  <section>
    <navbar-dashboard name="Editar destino" v-if="currentStep === 1"></navbar-dashboard>
    <section class="ew-smaller-container" v-if="currentStep === 1">
      <div class="ew-card">
        <form @submit.prevent="updateShipment" class="ew-form">
          <div class="ew-form__row">
            <div class="ew-form__field">
              <label class="ew-label" for="edd-name">Nombre completo de quien recibe</label>
              <input id="edd-name" type="text" maxlength="35" class="ew-input ew-input--block" v-model.trim="destination_direction.full_name" required>
            </div>
            <div class="ew-form__field">
              <label class="ew-label" for="edd-email">Correo electrónico de quien recibe</label>
              <input id="edd-email" type="text" class="ew-input ew-input--block" v-model.trim="destination_direction.email" required>
            </div>
          </div>

          <div class="ew-form__row">
            <div class="ew-form__field">
              <label class="ew-label" for="edd-phone">Teléfono de contacto</label>
              <input id="edd-phone" type="tel" pattern="[0-9]{3,25}" class="ew-input ew-input--block" v-model.trim="destination_direction.phone" required>
            </div>
            <div class="ew-form__field">
              <label class="ew-label" for="edd-address">Dirección de destino *</label>
              <input id="edd-address" type="text" maxlength="35" class="ew-input ew-input--block" v-model.trim="destination_direction.address" required>
            </div>
          </div>

          <div class="ew-form__row">
            <div class="ew-form__field">
              <label class="ew-label" for="edd-reference">Referencias de destino</label>
              <input id="edd-reference" type="text" maxlength="35" class="ew-input ew-input--block" v-model.trim="destination_direction.reference_of_origin">
            </div>
            <div class="ew-form__field">
              <label class="ew-label" for="edd-colony">Colonia</label>
              <input id="edd-colony" type="text" max="35" class="ew-input ew-input--block" v-model.trim="destination_direction.colony" required>
            </div>
          </div>

          <div class="ew-form__row">
            <div class="ew-form__field">
              <label class="ew-label" for="edd-zip">Código postal</label>
              <input id="edd-zip" type="number" max="999999999999" class="ew-input ew-input--block" v-model.trim="destination_direction.postal_code" @keyup="checkAddressDestination" required>
            </div>
            <div class="ew-form__field">
              <label class="ew-label" for="edd-city">Estado y ciudad</label>
              <input id="edd-city" type="text" maxlength="35" class="ew-input ew-input--block" v-model.trim="destination_direction.city" disabled required>
            </div>
          </div>

          <div class="ew-form__actions">
            <router-link class="ew-btn-outline" :to="'/shipments/' + $route.params['id']">Cancelar</router-link>
            <button class="ew-btn-primary" type="button" v-if="zipChanged" @click="currentStep = 2">Seleccionar paquetería</button>
            <button class="ew-btn-primary" type="submit" v-if="!zipChanged">Aplicar cambios</button>
          </div>
        </form>
      </div>
    </section>
    <ServiceProviderSelector v-if="currentStep === 2" :origin="origin_direction" :destination="destination_direction" :parcels="parcels" :insurance="insurance_information" :primary-action-text="primaryActionText" :secondary-action-text="secondaryActionText" @primary-action="updateShipmentWithNewSO" @secondary-action="currentStep = 1" />
  </section>
</template>

<script>
import axios from 'axios'
import commons from '../../commons'
import api from '../../commons/api'
import ServiceProviderSelector from '../ServiceProviderSelector'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Navbar from '../Header/Navbar'
export default {
  name: 'EditShipmentDestination',
  data () {
    return {
      currentStep: 1,
      initialDestinationZipCode: '',
      newShipmentOptionSelected: true,

      destination_direction: {
        full_name: '',
        email: '',
        phone: '',
        address: '',
        reference_of_origin: '',
        colony: '',
        postal_code: '',
        state_code: '',
        city: '',
        country_code: 'MX'
      },

      selectedService: null,

      requestBody: {
        destination_direction: {
          country_code: '',
          postal_code: '',
          city: '',
          suburb: ''
        }
      },

      primaryActionText: 'Aplicar Cambios',
      secondaryActionText: 'Cancel'
    }
  },
  methods: {
    calculateQuote () {
      /*
      console.log('calculateQuote')

      this.requestBody.parcels = this.parcels

      this.requestBody.origin_direction = {
        country_code: this.origin_direction.country_code,
        postal_code: this.origin_direction.postal_code,
        city: this.origin_direction.city,
        suburb: this.origin_direction.colony
      }

      this.requestBody.destination_direction = {
        country_code: this.destination_direction.country_code,
        postal_code: this.destination_direction.postal_code,
        city: this.destination_direction.city,
        suburb: this.destination_direction.colony
      }

      if (this.package_insurance) {
        this.insured_value = this.insurance_information.cost
      } else {
        delete this.insured_value
      }

      this.setQuotingRequestBody(this.requestBody)

      this.quoting()
        .then(() => {
          this.nextStep()
        })
        .catch(error => console.log(error))
      */
    },

    checkAddressDestination (event) {
      // console.log(event)
      const query = event.target.value
      if (query.length >= 5) {
        this.getLocationInfo(query, 'MX').then(response => {
          // console.log(response.data)
          this.destination_direction.city =
             response.data.country_codes[0].state + ', ' + response.data.country_codes[0].city
        })
      }
    },
    getLocationInfo (zipCode, countryCode) {
      return axios.get(
        `${
          commons.apiURL
        }/api/v1/postalcodes?search=${zipCode}&country=${countryCode}`
      )
    },
    updateShipment () {
      const requestBody = {
        destination_direction: this.destination_direction
      }

      this.setSelectedShippingOption(
        this.shippingOptions[this.selectedShippingOptionIndex]
      )

      this.setNewShipmentRequestBody(requestBody)
      api.shipment.update(this.$route.params['id'], requestBody).then(() => {
        this.getAllShipments()
        this.$router.push(`/shipments/${this.$route.params['id']}`)
      })
    },

    updateShipmentWithNewSO (newSO) {
      const requestBody = {
        destination_direction: this.destination_direction,
        selected_service: newSO
      }

      this.setNewShipmentRequestBody(requestBody)

      api.shipment.update(this.$route.params['id'], requestBody).then(() => {
        this.getAllShipments()
        this.$router.push(`/shipments/${this.$route.params['id']}`)
      })
    },

    ...mapMutations([
      'netNewShipmentRequestBody',
      'setQuotingRequestBody',
      'setSelectedShippingOption',
      'setNewShipmentRequestBody'
    ]),
    ...mapActions(['quoting', 'newShipment', 'getAllShipments'])
  },
  computed: {
    zipChanged () {
      if (
        this.initialDestinationZipCode !==
        this.destination_direction.postal_code
      ) {
        return true
      } else {
        return false
      }
    },

    ...mapGetters([
      'quotingRequestBody',
      'selectedShippingOption',
      'serviceProviders',
      'shippingOptions'
    ])
  },
  components: {
    ServiceProviderSelector: ServiceProviderSelector,
    'navbar-dashboard': Navbar
  },
  created () {
    api.shipment.getByID(this.$route.params['id']).then(response => {
      this.origin_direction = response.data.origin_direction
      this.destination_direction = response.data.destination_direction
      this.parcels = response.data.parcels
      this.insurance_information = response.data.insurance_information
      this.initialDestinationZipCode = this.destination_direction.postal_code
    })
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/styles/app-tokens";
@import "../../assets/styles/ew-components";

.ew-smaller-container { @include app-tokens; max-width: 700px; margin: 2.5rem auto; padding: 0 1rem 4rem; }
.ew-card { @include ew-card; padding: 1.5rem 1.75rem; }
.ew-btn-primary { @include ew-btn-primary; }
.ew-btn-outline { @include ew-btn-outline; }
.ew-form { display: flex; flex-direction: column; gap: 1rem; max-width: none; }
.ew-form__row { display: flex; flex-wrap: wrap; gap: 1rem; > .ew-form__field { flex: 1 1 220px; min-width: 0; } }
.ew-form__field { display: flex; flex-direction: column; gap: 0.4rem; }
.ew-form__actions { display: flex; justify-content: flex-end; gap: 0.6rem; }
.ew-label { font-family: var(--app-font); font-size: 0.8rem; font-weight: 700; color: var(--app-navy); }
.ew-input { @include ew-input; }
.ew-input--block { width: 100%; }
</style>



// WEBPACK FOOTER //
// src/components/editShipment/EditShipmentDestination.vue